import { 
  Directive, 
  ElementRef,
  EventEmitter, 
  HostListener, 
  Input, 
  OnDestroy, 
  OnInit, 
  Output, 
  Renderer2 
} from '@angular/core';
import { Subject, Subscription, timer } from 'rxjs';
import { throttleTime } from 'rxjs/operators';

@Directive({
  selector: '[debouncedClick]'
})
export class DebouncedClickDirective implements OnInit, OnDestroy {
  @Input() 
  throttleTime = 2000;

  @Output() 
  throttleClick = new EventEmitter();

  @Output('debouncedClick')
  debouncedClick = this.throttleClick;
  
  private clicks = new Subject<any>();
  private subscription: Subscription = new Subscription();
  private timerSub?: Subscription;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2
  ) { }

  ngOnInit() {
    this.subscription.add(
      this.clicks.pipe(
        throttleTime(this.throttleTime)
      ).subscribe(e => {
        this.applyThrottlingState();
        this.throttleClick.emit(e);
      })
    );
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    if (this.timerSub) {
      this.timerSub.unsubscribe();
    }
    this.clearThrottlingState();
  }

  @HostListener('click', ['$event'])
  clickEvent(event: any) {
    event.preventDefault();
    event.stopPropagation();
    this.clicks.next(event);
  }

  private applyThrottlingState() {
    this.renderer.addClass(this.el.nativeElement, 'is-throttling');
    this.renderer.setStyle(this.el.nativeElement, 'pointer-events', 'none');
    this.renderer.setStyle(this.el.nativeElement, 'opacity', '0.65');
    this.renderer.setStyle(this.el.nativeElement, 'cursor', 'not-allowed');

    if (this.timerSub) {
      this.timerSub.unsubscribe();
    }
    this.timerSub = timer(this.throttleTime).subscribe(() => {
      this.clearThrottlingState();
    });
  }

  private clearThrottlingState() {
    this.renderer.removeClass(this.el.nativeElement, 'is-throttling');
    this.renderer.removeStyle(this.el.nativeElement, 'pointer-events');
    this.renderer.removeStyle(this.el.nativeElement, 'opacity');
    this.renderer.removeStyle(this.el.nativeElement, 'cursor');
  }
}
